import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_4 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_5 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_6 = { class: "mt-6 text-center" }
const _hoisted_7 = { class: "mt-4 text-center" }
const _hoisted_8 = { class: "font-normal text-sm text-gray-600 text-center mt-2" }
const _hoisted_9 = { class: "mt-6 flex justify-around items-center" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_12 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_13 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_14 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_15 = { class: "mt-6 text-center" }
const _hoisted_16 = { class: "font-normal text-sm text-gray-600 text-center mt-2" }
const _hoisted_17 = { class: "flex justify-around items-center" }

import { ref } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalArchiveContentModals',
  props: {
    archiveRequestSuccess: {
        type: Boolean,
        required: true,
    },
    archiveRequestFailed: {
        type: Boolean,
        required: true,
    },
    actionType: {
        type: String,
        required: true,
    },
},
  emits: ["closeSuccessFailModal"],
  setup(__props, { emit }) {

const props = __props;




const confirmAssignLearnersModal = ref(false);

const closeSuccessFailModal = () => {
  emit("closeSuccessFailModal");
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.archiveRequestSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(TransitionRoot), {
            as: "template",
            show: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                as: "div",
                class: "relative z-40",
                onClose: _cache[0] || (_cache[0] = ($event: any) => (confirmAssignLearnersModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: "absolute top-6 right-4 cursor-pointer",
                                  onClick: closeSuccessFailModal
                                }, [
                                  _createVNode(_component_rl_icon, {
                                    icon: 'rl-large-close',
                                    title: 'rl large close',
                                    "aria-hidden": "true"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_rl_icon, {
                                      icon: 'rl-green-tick',
                                      title: 'rl green tick',
                                      "aria-hidden": "true"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_unref(DialogTitle), {
                                    as: "h3",
                                    class: "mt-6 font-semibold text-2xl text-gray-900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.complete")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("archive_flow.modals.success_message", { type: __props.actionType })), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("button", {
                                  onClick: closeSuccessFailModal,
                                  type: "button",
                                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
                                }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (props.archiveRequestFailed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(TransitionRoot), {
            as: "template",
            show: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                as: "div",
                class: "relative z-40",
                onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmAssignLearnersModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: "absolute top-6 right-4 cursor-pointer",
                                  onClick: closeSuccessFailModal
                                }, [
                                  _createVNode(_component_rl_icon, {
                                    icon: 'rl-large-close',
                                    title: 'rl large close',
                                    "aria-hidden": "true"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_rl_icon, {
                                    icon: 'rl-exclamation-bg-logo',
                                    title: 'rl exclamation bg logo',
                                    "aria-hidden": "true"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_unref(DialogTitle), {
                                    as: "h3",
                                    class: "mt-6 font-semibold text-2xl text-gray-900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.incomplete")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("archive_flow.modals.error_message")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", {
                                  onClick: closeSuccessFailModal,
                                  type: "button",
                                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
                                }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})